const FALLBACK_LOCALE = 'en'

export { FALLBACK_LOCALE }
